export default __webpack_public_path__ + "static/media/person_2@2x.176aa319.png";